import SanitizedGrid from "../../../components/SanitizedGrid";
import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import {
  FormDataConsumer,
  RadioButtonGroupInput,
  required,
  SimpleForm,
  TextInput,
} from "react-admin";
import React, { useState } from "react";
import { AcademicYearResources, sumCentsAmountToDolar } from "utils/tools";
import moment from "moment/moment";
import CustomStudentScheduleDateInput from "../../../components/CustomStudentScheduleDateInput";
import DaysOfWeekInput from "../../../components/DaysOfWeekInput";
import AddressAutoCompleteInput from "../../../components/AddressAutoCompleteInput";
import CalculationCostStudentButton from "./CalculationCostStudentButton";
import AcademicYearInput from "./AcademicYearInput";

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
});

const CalculateAreaInput = () => {
  const [resultCalculations, setResultCalculations] = useState<
    IResultCalculation[]
  >([]);
  const [idAcademicYear, setIdAcademicYear] = useState<number>(0);
  const [isLoaded, setIsLoaded] = useState(false);

  const classes = useStyles();
  const format = "DD/MM/YY";

  const callback = (value: number) => {
    setIdAcademicYear(value);
  };

  const academicYearResources = AcademicYearResources(idAcademicYear);

  return (
    <SimpleForm toolbar={null}>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Schedule</Typography>
        </Grid>

        <Grid item xs={4}>
          <AcademicYearInput parentCallback={callback} />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <CustomStudentScheduleDateInput
            source="date"
            label="Start Date"
            referenceSource={academicYearResources}
          />
        </Grid>

        <Grid item xs={12}>
          <RadioButtonGroupInput
            label="To and/or From"
            source="wayType"
            choices={[
              { id: "OneWayMorning", name: "Morning (Bus to School)" },
              {
                id: "OneWayAfternoon",
                name: "Afternoon (Bus from School)",
              },
              { id: "TwoWay", name: "Both" },
            ]}
            validate={required()}
          />
        </Grid>

        <DaysOfWeekInput />

        <Grid item xs={12}>
          <Typography variant="h6">Pick up & Drop off Address</Typography>
        </Grid>

        <Grid item xs={4}>
          <AddressAutoCompleteInput
            label="Postal Code *"
            source="postalCode"
            referenceSource="locationData"
          />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={2}>
          <TextInput label="Unit No." source="unit" />
        </Grid>
        <Grid item xs={2}>
          <TextInput label="Block No." source="blockNumber" />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <TextInput label="Building Name" source="building" />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <TextInput label="Street" source="street" validate={required()} />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={12}>
          {isLoaded && (
            <SanitizedGrid container spacing={2}>
              {resultCalculations.length > 0 ? (
                <>
                  {resultCalculations.map(
                    (resulCalculation: IResultCalculation) => (
                      <Grid item xs={12}>
                        <Typography variant="h6">
                          Cost Preview for Rate Chart #
                          {resulCalculation.rateChart.id} -{" "}
                          {resulCalculation.rateChart.name}
                        </Typography>
                        <TableContainer>
                          <Table className={classes.table} size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>Schedule Date</TableCell>
                                <TableCell>Amount</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {resulCalculation.transactions.map(
                                (item: IResultCalculationItem, i) => {
                                  return (
                                    <TableRow key={i}>
                                      <TableCell>
                                        {moment
                                          .utc(item.fromDate)
                                          .format(format)}{" "}
                                        -{" "}
                                        {moment.utc(item.toDate).format(format)}
                                      </TableCell>
                                      <TableCell>
                                        $ {item.total.toFixed(2) / 100}
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              )}

                              <TableRow>
                                <TableCell>Total :</TableCell>
                                <TableCell>
                                  ${" "}
                                  {sumCentsAmountToDolar(
                                    resulCalculation.transactions
                                  )}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    )
                  )}
                </>
              ) : (
                <Grid item xs={12}>
                  <Typography variant="h6">No Change in Cost.</Typography>
                </Grid>
              )}
            </SanitizedGrid>
          )}
        </Grid>

        <Grid item xs={12}>
          <FormDataConsumer>
            {({ formData }) => {
              return (
                <div>
                  <CalculationCostStudentButton
                    setResultCalculations={setResultCalculations}
                    setIsLoaded={setIsLoaded}
                    formData={formData}
                  />
                </div>
              );
            }}
          </FormDataConsumer>
        </Grid>
      </SanitizedGrid>
    </SimpleForm>
  );
};

export default CalculateAreaInput;
